﻿import { UserProfile } from '@lingvo-news/contracts';
import { User } from './auth-service';

export abstract class ICurrentUserStore {
	abstract initialize(): Promise<void>;
	abstract refresh(): Promise<void>;

	abstract getCurrentUserId(): string | null;

	abstract getCurrentUser(): UserProfile | null;

	abstract logout(): Promise<void>;
}
